import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  FlatList,
  ScrollView,
} from "react-native";
import { Octicons } from "@expo/vector-icons";
import moment from "moment";
import { CheckBox } from 'react-native';
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";

const { width, height } = Dimensions.get("window");
export default function tableuser({ navigation, data }) {
  const [currentData, setCurrentData] = useState(data);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const token = useRecoilValue(tokenState);
  const [selectAll, setSelectAll] = useState(false);
  const currentOrder = useRef("asc");

  function orderBy(key, orderBy = "asc") {
    const sortedData = [...currentData].sort((a, b) => {
      if (orderBy === "asc") {
        return a[key] > b[key] ? 1 : -1;
      } else {
        return a[key] < b[key] ? 1 : -1;
      }
    });
    setCurrentData(sortedData);
  }

  useEffect(() => {
    setCurrentData(data);
  }, [data]);

  useEffect(() => {
    if (selectAll) {
      setSelectedUsers(currentData.map((item) => item.id));
    } else {
      setSelectedUsers([]);
    }
  }, [selectAll, currentData]);

  const toggleUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
    );
  };

  const handleBlockSelected = (status) => {
    return async () => {
      if (selectedUsers.length === 0) return;

      await Promise.all(
        selectedUsers.map((userId) => {
          const user = currentData.find((item) => item.id === userId);
          if (user) {
            return updateUserStatus(user, status);
          }
        })
      );
    }
  };

  const updateUserStatus = async (user, status) => {
    const response = await apiservice({
      path: "/admin/edit-profile",
      method: "put",
      body: { ...user, link: status === "Active" },
      token: token.accessToken,
    });
    if (response?.status === 200) {
      setCurrentData((prevData) =>
        prevData.map((item) =>
          item.id === user.id ? { ...item, link: status === "Active" }
            : item
        )
      );
    }
    return response;
  };

  return (
    <View style={styles.back}>
      <View style={{ flexDirection: 'row', padding: 10, alignSelf: 'flex-end' }}>
        {selectedUsers.length > 0 && <TouchableOpacity
          style={{ margin: 10, backgroundColor: '#000', padding: 10, borderRadius: 5, alignSelf: 'flex-end' }}
          onPress={handleBlockSelected("Active")}
          disabled={selectedUsers.length === 0}
        >
          <Text style={{ color: '#fff', fontWeight: 'bold' }}>Active</Text>
        </TouchableOpacity>}

        {selectedUsers.length > 0 && <TouchableOpacity
          style={{ margin: 10, backgroundColor: '#ff4d4f', padding: 10, borderRadius: 5, alignSelf: 'flex-end' }}
          onPress={handleBlockSelected("Block")}
          disabled={selectedUsers.length === 0}
        >
          <Text style={{ color: '#fff', fontWeight: 'bold' }}>Block</Text>
        </TouchableOpacity>}
      </View>

      <ScrollView horizontal showsHorizontalScrollIndicator={true}>
        <View style={{ minWidth: 1200 }}>
          <View style={styles.head}>
            <View style={[styles.viewhead, { width: 40, alignItems: 'center', justifyContent: 'center', paddingVertical: 10 }]}>
              <CheckBox
                value={selectAll}
                onValueChange={setSelectAll}
              />
            </View>
            <View style={[styles.viewhead, { width: 250, paddingHorizontal: 10, paddingVertical: 10 }]}>
              <Text style={styles.texthead}>User</Text>
            </View>
            <View style={[styles.viewhead, { width: 250, paddingHorizontal: 10, paddingVertical: 10 }]}>
              <Text style={styles.texthead}>Username</Text>
            </View>
            <View style={[styles.viewhead, { width: 250, paddingHorizontal: 10, paddingVertical: 10 }]}>
              <Text style={styles.texthead}>Email</Text>
            </View>
            <View style={[styles.viewhead, { width: 100, paddingHorizontal: 10, paddingVertical: 10, alignItems: 'center' }]}>
              <Text style={styles.texthead}>ID</Text>
            </View>
            <View style={[styles.viewhead, { width: 100, paddingHorizontal: 10, paddingVertical: 10, alignItems: 'center' }]}>
              <Text style={styles.texthead}>Role</Text>
            </View>
            <View style={[styles.viewhead, { width: 100, paddingHorizontal: 10, paddingVertical: 10, alignItems: 'center' }]}>
              <Text style={styles.texthead}>Status</Text>
            </View>
            <TouchableOpacity onPress={() => {
              currentOrder.current = currentOrder.current === 'asc' ? 'desc' : 'asc';
              orderBy('createdAt', currentOrder.current);
            }} style={[styles.viewhead, { width: 200, paddingHorizontal: 10, paddingVertical: 10, alignItems: 'center' }]}>
              <Text style={styles.texthead}>Created At</Text>
            </TouchableOpacity>
          </View>

          <FlatList
            data={currentData}
            scrollEnabled
            renderItem={({ index, item }) => {
              return (
                <View>
                  <View style={[styles.viewmain, { backgroundColor: "#fff" }]}>
                    <View style={{ width: 40, alignItems: 'center', justifyContent: 'center', paddingVertical: 5 }}>
                      <CheckBox
                        value={selectedUsers.includes(item.id)}
                        onValueChange={() => toggleUser(item.id)}
                      />
                    </View>
                    {item.role == "ADMIN" && (
                      <TouchableOpacity
                        onPress={() => navigation.navigate("ProflieUser", { item })}
                        style={[styles.viewdetail, { width: 250, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center' }]}
                      >
                        <Image
                          source={{ uri: item.image_Profile }}
                          style={styles.img}
                        />
                        <View style={{ flex: 1 }}>
                          <Text numberOfLines={1} style={[styles.textDetail]}>{item?.name || item?.username}</Text>
                        </View>
                      </TouchableOpacity>
                    )}
                    {item.role == "EVENT" && (
                      <TouchableOpacity
                        onPress={() => navigation.navigate("ProflieUser", { item })}
                        style={[styles.viewdetail, { width: 250, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center' }]}
                      >
                        <Image
                          source={{ uri: item.image_Profile }}
                          style={styles.img}
                        />
                        <View style={{ flex: 1 }}>
                          <Text numberOfLines={1} style={[styles.textDetail]}>{item?.name || item?.username}</Text>
                        </View>
                      </TouchableOpacity>
                    )}
                    {item.role == "USER" && (
                      <TouchableOpacity
                        onPress={() => navigation.navigate("ProflieUser", { item })}
                        style={[styles.viewdetail, { width: 250, paddingHorizontal: 10, paddingVertical: 5 }]}
                      >
                        <Image
                          source={{ uri: item.image_Profile }}
                          style={styles.img}
                        />
                        <View style={{ flex: 1 }}>
                          <Text numberOfLines={1} style={[styles.textDetail]}>{item?.name || item?.username}</Text>
                        </View>
                      </TouchableOpacity>
                    )}
                    {item.role == "VIP" && (
                      <TouchableOpacity
                        onPress={() => navigation.navigate("ProflieVip", { item })}
                        style={[styles.viewdetail, { width: 250, paddingHorizontal: 10, paddingVertical: 5 }]}
                      >
                        <Image
                          source={{ uri: item.image_Profile }}
                          style={styles.img}
                        />
                        <View style={{ flex: 1 }}>
                          <Text numberOfLines={1} style={styles.textDetail}>
                            {item?.name || item?.username}
                          </Text>
                        </View>
                      </TouchableOpacity>
                    )}
                    <View style={[styles.viewdetail, { width: 250, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center' }]}>
                      <Text numberOfLines={1} style={styles.textdate}>{item?.username}</Text>
                    </View>
                    <View style={[styles.viewdetail, { width: 250, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center' }]}>
                      <Text numberOfLines={1} style={styles.textdate}>{item.email}</Text>
                    </View>
                    <View style={[styles.viewdetail, { width: 100, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center', justifyContent: "center" }]}>
                      <Text style={styles.textdate}>{item.id + 100000}</Text>
                    </View>
                    <View style={[styles.viewdetail, { width: 100, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center', justifyContent: "center" }]}>
                      <Text style={styles.textdate}>{item.role}</Text>
                    </View>
                    <View style={[styles.viewdetail, { width: 100, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center', justifyContent: "center" }]}>
                      <Octicons
                        name="dot-fill"
                        size={16}
                        color={!item?.link ? "#ff0000" : "#2DCE98"}
                        style={{ marginRight: 5 }}
                      />
                      <Text style={styles.textdate}>
                        {!item?.link ? "Block" : "Active"}
                      </Text>
                    </View>
                    <View style={[styles.viewdetail, { width: 200, paddingHorizontal: 10, paddingVertical: 5, alignItems: 'center', justifyContent: "center" }]}>
                      <Text style={styles.textdate}>{moment(item.createdAt).format('dd DD-MM-YYYY HH:mm ')}</Text>
                    </View>
                  </View>
                </View>
              );
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: "100%",
    height: "73%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: "100%",
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    borderBottomWidth: 1,
    borderBottomColor: "#E1E5E9",
  },
  viewhead: {
    justifyContent: 'center',
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewdetail: {
    flexDirection: "row",
  },
  img: {
    width: 39,
    height: 39,
    marginTop: 5,
    backgroundColor: "#393939",
  },
  textDetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#393939",
    marginLeft: 10,
    alignSelf: "center",
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: 15,
  },
  viewmain: {
    flexDirection: "row",
    width: "100%",
    minHeight: 60,
    borderBottomWidth: 0.5,
    borderBottomColor: "#E1E5E9",
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#172B4D",
    textAlign: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
});
